export default {
	//endpoint: "http://sandbox.sgt/studiogt"
	//endpoint: "https://drop.studiogt.com.br/studiogt-2018"
	endpoint: "https://www.studiogt.com.br"
};
